import React from "react";
import { Card } from "react-bootstrap";
import "../../resources/styles/components/contact-card.scss";

type Props = {
    toggleActiveCardHandler: () => void,
    mobile?: string,
    email?: string, 
    activeCard: boolean,
    className: string,
};

type State = {
    contactType: string,
    contactText: string,
    contactSelectOption: string,
};

/**
 * Component to display either phone number or email information associated with the user.
 */
export default class ContactCard extends React.Component<Props, State>{
	constructor(props:Props) {
		super(props);

		this.state = {
            contactType: (this.props.mobile ? "a text message" : "an email"),
            contactText: (this.props.mobile ? "phone number" : "email address"),
            contactSelectOption: (this.props.mobile ? "Mobile Number" : "Email Address")
		}
	}

	render() {
		return (
            <Card className={"contact-card " + this.props.className + " " + (this.props.activeCard ? "active-border" : "")} onClick={(this.props.activeCard) ? () => {} : () => this.props.toggleActiveCardHandler()}>
                <Card.Body>
                    <h4 className="contact-card-header mt-0 mb-10">
                        Send me {this.state.contactType}
                    </h4>
                    <div className="contact-card-info-text">
                        A security code will be sent to the following {this.state.contactText}:
                    </div>
                    <div className="contact-card-form-group">
                        <div className="option-header">{this.state.contactSelectOption}</div>
                    
                        {(this.props.mobile && this.props.mobile.length > 0) ?
                                <div className="font-weight-bold email-option">
                                    <hr className="email-hr"></hr>
                                    {this.props.mobile}
                                </div>
                        :
                            <div className="font-weight-bold email-option">
                                <hr className="email-hr"></hr>
                                {this.props.email !== undefined && this.props.email}
                            </div>
                        }
                    </div>
                </Card.Body>
                <Card.Footer className={"contact-card-footer " + (this.props.activeCard ? "active active-border" : "")}>
                    <span className={"circle-icon " + (this.props.activeCard ? "mp-icon-circle-check-filled" : "mp-icon-circle-check-unfilled")}/>
                </Card.Footer>
            </Card>           
		);
	}
}